import Map from "./Map";
import { defaultLineString } from "./Map";

export default Map;
export { defaultLineString };
